import { useState, useEffect, useRef } from 'react'
import { reaction } from 'mobx'
import { FormField } from '@/Core/UI/Form'
import { FormContextProvider, createFormContext } from '@/Core/UI/Form/Providers'

export const FormFieldCellTemplate: React.FC<{ field: any; children: React.ReactNode }> = ({ children }) => (
    <div className="form-field form-field-default" style={{ paddingBottom: 0 }}>
        {children}
    </div>
)

export interface NumberFormFieldCellProps {
    fieldName: string
    initialValue: any
    onChange: (val: any) => void
    inputProps?: Record<string, any>
}

export const NumberFormFieldCell: React.FC<NumberFormFieldCellProps> = ({ fieldName, initialValue, onChange, inputProps }) => {
    const savedValue = useRef(initialValue)
    const [formStore] = useState(() =>
        createFormContext({
            fields: { [fieldName]: { type: 'number', isEditable: true, inputProps } },
            initialValues: { [fieldName]: initialValue },
            isEditable: true,
        })
    )

    useEffect(() => {
        const dispose = reaction(
            () => formStore.getValue(fieldName),
            (val: any) => {
                if (val !== savedValue.current) {
                    savedValue.current = val
                    onChange(val)
                }
            }
        )
        return () => dispose()
    }, [formStore, fieldName, onChange])

    return (
        <FormContextProvider value={formStore}>
            <FormField name={fieldName} template={FormFieldCellTemplate} ignoreParentField={true} />
        </FormContextProvider>
    )
}
